/**
 * Theme Manager - Handles light/dark mode switching
 */

export const THEME_LIGHT = 'light';
export const THEME_DARK = 'dark';
export const STORAGE_KEY = 'theme-preference';

/**
 * Get the current theme from localStorage or system preference
 */
export function getCurrentTheme() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === THEME_LIGHT || stored === THEME_DARK) {
        return stored;
    }

    // Check system preference
    if (window.matchMedia?.('(prefers-color-scheme: dark)').matches) {
        return THEME_DARK;
    }

    return THEME_LIGHT;
}

/**
 * Set the theme and apply it to the document
 */
export function setTheme(theme) {
    const validTheme = theme === THEME_DARK ? THEME_DARK : THEME_LIGHT;
    localStorage.setItem(STORAGE_KEY, validTheme);

    if (validTheme === THEME_DARK) {
        document.documentElement.setAttribute('data-theme', THEME_DARK);
    } else {
        document.documentElement.removeAttribute('data-theme');
    }

    return validTheme;
}

/**
 * Toggle between light and dark mode
 */
export function toggleTheme() {
    const current = getCurrentTheme();
    const newTheme = current === THEME_LIGHT ? THEME_DARK : THEME_LIGHT;
    return setTheme(newTheme);
}

/**
 * Initialize theme on page load
 */
export function initializeTheme() {
    const theme = getCurrentTheme();
    if (theme === THEME_DARK) {
        document.documentElement.setAttribute('data-theme', THEME_DARK);
    }
    return theme;
}
